module.exports = __webpack_public_path__ + "img/en_badge_appstore.f1edc5ba.png";